import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";

const KundliProcess = () => {
  const compatibilityData = [
    { check: "Compatibility Check", result: "Finds out if the couple is emotionally, mentally, and physically compatible" },
    { check: "Dosha Detection", result: "Shows if there are doshas that may cause health issues, stress, or delays in marriage." },
    { check: "Guna Matching", result: "Gives scores that reveal if the relationship will be beneficial or challenging." },
    { check: "Marriage Problems", result: "Helps detect possible issues early so they can be managed" },
    { check: "Emotional & Spiritual Harmony", result: "Ensures peace, balance, and avoids social or legal conflicts in married life." }
  ];

  const benefits = [
    {
      title: "Your Personal Kundli",
      description: "एक पीडीएफ रिपोर्ट जो आपको कई महत्वपूर्ण ज्योतिषीय तथ्यों पर आवश्यक अंतर्दृष्टि देती है",
      bgColor: "bg-gradient-to-br from-red-600 to-red-700"
    },
    {
      title: "Kundli Matching Report",
      description: "एक विस्तृत रिपोर्ट जो बताती है कि आप अपने साथी के साथ कैसा संबंध साझा करते हैं",
      bgColor: "bg-gradient-to-br from-red-500 to-red-600"
    },
    {
      title: "Guna Milan Score",
      description: "आपकी व्यक्तित्व, व्यवहार और सामाजिक संबंधों के विभिन्न ज्योतिषीय पहलुओं पर आधारित अंकों को दर्शाता है",
      bgColor: "bg-gradient-to-br from-red-600 to-red-700"
    },
    {
      title: "Personal Kundli Details",
      description: "चंद्र कुंडली से नवांश तक, यह आपको कई महत्वपूर्ण ज्योतिषीय तथ्यों पर आवश्यक अंतर्दृष्टि देता है",
      bgColor: "bg-gradient-to-br from-red-600 to-red-700"
    },
    {
      title: "Dosha Check",
      description: "जाँच करें कि क्या कोई दोष जैसे मांगलिक दोष, नाड़ी दोष आदि हैं जो जीवन या विवाह में समस्याएँ उत्पन्न करते हैं",
      bgColor: "bg-gradient-to-br from-red-500 to-red-600"
    },
    {
      title: "Lagna Charts",
      description: "ग्रहों की स्थिति दोनों साझेदारों की कुंडली में कैसी है, यह दर्शाने वाले चार्ट",
      bgColor: "bg-gradient-to-br from-red-600 to-red-700"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-background_km to-muted_km">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground_km mb-6">
            How Does Kundali Milan Work?
          </h2>
          <p className="text-lg text-muted_km-foreground max-w-6xl mx-auto leading-relaxed mb-8">
            In the past, family priests or astrologers did Kundali matching for marriage. Now, you can do it online in just minutes with accurate results.
          </p>
          <h3 className="text-2xl font-semibold text-foreground_km mb-12">
            Two Main Methods of Kundali Matching
          </h3>
        </div>

        {/* Two Methods */}
        <div className="grid md:grid-cols-2 gap-8 mb-16 max-w-6xl mx-auto">
          <Card className="bg-gradient-to-br from-red-800 to-red-900 text-white border-0">
            <CardHeader>
              <CardTitle className="text-2xl text-center text-yellow-300">
                Astrology Match Making
              </CardTitle>
            </CardHeader>
            <CardContent className="text-center space-y-4">
              <p className="leading-relaxed">
                Also called Kundli or Guna Matching. It compares details like date, time, and place of birth of both partners. It also uses names and dates of birth to study future aspects of the relationship through astrology.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-gradient-to-br from-red-700 to-red-800 text-white border-0">
            <CardHeader>
              <CardTitle className="text-2xl text-center text-yellow-300">
                Numerology Match Making
              </CardTitle>
            </CardHeader>
            <CardContent className="text-center space-y-4">
              <p className="leading-relaxed">
                This method looks at numbers related to date, time, and place of birth. It follows traditional systems to check compatibility in a simple and authentic way.
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Process Description */}
        <div className="text-center mb-16 max-w-6xl mx-auto">
          <p className="text-lg text-muted_km-foreground leading-relaxed">
            Once The Kundli Match Online Is Done Using Astrological Method, Couples Can Gain Insight Into Their Astrological Charts, Helping Them Make Informed Marriage Decisions. For More Accurate Results And Personalized Remedies, Consulting A Skilled Astrologer Is Highly Recommended.
          </p>
        </div>

        {/* Compatibility Table Section */}
        <div className="bg-gradient-to-r from-orange-400 via-red-400 to-orange-500 rounded-2xl p-8 mb-16">
          <h3 className="text-3xl lg:text-4xl font-bold text-white text-center mb-2">
            Why Kundali Matching is Important
          </h3>
          <p className="text-white text-center mb-6">Kundali Matching helps make sure a marriage will be smooth and happy by checking different aspects:</p>
          <div className="bg-white rounded-lg overflow-hidden shadow-lg">
            <div className="grid md:grid-cols-2 bg-orange-200">
              <div className="p-4 font-bold text-center border-r border-orange-300">
                Compatibility Check
              </div>
              <div className="p-4 font-bold text-center">
                Recommend Marriage (Emotional, Mental, or Physical Compatibility)
              </div>
            </div>

            {compatibilityData.map((row, index) => (
              <div key={index} className="grid md:grid-cols-2 border-b border-gray-200 last:border-b-0">
                <div className="p-4 bg-orange-100 border-r border-gray-200 font-medium">
                  {row.check}
                </div>
                <div className="p-4 bg-orange-50">
                  {row.result}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Benefits Section */}
        <div className="text-center mb-12">
          <h3 className="text-4xl lg:text-5xl font-bold text-foreground_km mb-6">
            What Do You Get From Kundli Milan Online?
          </h3>
          <p className="text-lg text-muted_km-foreground max-w-4xl mx-auto leading-relaxed">
            With guidance from Acharya Lav Bhushan, Kundli Milan Online provides a complete, easy-to-read report on your marital compatibility. The report includes a detailed analysis of your horoscopes, covering key aspects of your future together.
          </p>
        </div>
       
        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {benefits.map((benefit, index) => (
            <Card key={index} className={`${benefit.bgColor} text-white border-0 hover:scale-105 transition-all duration-300`}>
              <CardHeader>
                <CardTitle className="text-xl text-center text-yellow-300">
                  {benefit.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="text-center">
                <p className="leading-relaxed text-sm">
                  {benefit.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
         <div className="text-center my-8 max-w-6xl mx-auto">
          
        </div>
      </div>
    </section>
  );
};

export default KundliProcess;